import {outter_post} from 'common/js/axios-helper';
import {RongBaoApi} from "./constant/UrlMapper";


const host="8883"   //测试



const registList = (data) => {
    return outter_post(RongBaoApi.RegistList, data, host);
};

const bindList = (data) => {
    return outter_post(RongBaoApi.BindList, data, host);
};

export default {registList, bindList}



// WEBPACK FOOTER //
// ./src/service/RongBaoService.js